export const IMPERSONATION_COOKIE_NAME = 'impersonationSessionActive';
export const hasImpersonationCookie = () => document.cookie.split('; ').some((entry) => entry.startsWith(`${IMPERSONATION_COOKIE_NAME}=`));
export const setImpersonationCookie = () => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${IMPERSONATION_COOKIE_NAME}=1; path=/; SameSite=Lax${secure}`;
};
export const clearImpersonationCookie = () => {
    document.cookie = `${IMPERSONATION_COOKIE_NAME}=; path=/; Max-Age=0`;
};
export const IMPERSONATION_LINK_PROCESSED_KEY = 'impersonationLinkProcessed';
export const markImpersonationLinkProcessed = (sessionStartTime) => sessionStorage.setItem(IMPERSONATION_LINK_PROCESSED_KEY, sessionStartTime !== null && sessionStartTime !== void 0 ? sessionStartTime : '');
export const isImpersonationLinkProcessed = (sessionStartTime) => sessionStorage.getItem(IMPERSONATION_LINK_PROCESSED_KEY) === (sessionStartTime !== null && sessionStartTime !== void 0 ? sessionStartTime : '');
export const isImpersonating = (impersonationDetails) => !!impersonationDetails && Object.keys(impersonationDetails).length > 0;
